<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100 text-primary">SNN subsidie</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Waardevermeerderingsregeling
      </h5>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">

            <!-- <div class="small mb-4">
                <checkmark-item class="mb-2">
                  Het Samenwerkingsverband Noord-Nederland (SNN) heeft subsidieregelingen voor woningeigenaren die in het aardbevingsbebied wonen of erkende bevingsschade hebben.
                </checkmark-item>
                <checkmark-item class="mb-2">
                  Middels deze vragen controleren we of u in aanmerking komt voor een aanvraag.
                </checkmark-item>
            </div> -->

            <!-- section SNN 4000 euro -->
            <!-- <div v-show="true" class="fade-in-up-enter-active animation-slowest delay-200"> -->
            <h6 class="pb-3 mt-3 max-100">Subsidie Waardevermeerderingsregeling Groningen – &euro;4.000</h6>

            <div class="small mb-5">
              <checkmark-item class="mb-2">
                Bent u woning eigenaar of huurder met erkende aarbevingsschade van ten minste &euro;1.000?
              </checkmark-item>
              <checkmark-item class="mb-2">
                Heeft u niet eerder gebruik gemaakt van de tijdelijke regeling Waardevermeerdering die liep tot 2017?
              </checkmark-item>
              <p>
                Onder deze voorwaarden komt u waarschijnlijk in aanmerking voor deze subsidie van &euro;4.000 die u kunt gebruiken voor duurzame maatregelen aan uw woning. Meer informatie vind u op
                <a href="https://www.snn.nl/subsidies-voor-particulieren/subsidie-waardevermeerdering" target="_blank">de website van het SNN</a>.
              </p>
            </div>

            <base-input
              type="radiobuttons" :options="yesNoDontKnow"
              name="Consent"
              v-model:value="lead.financing.snnSubsidy4k.RequestedSnn4k" :validator="v$.financing.snnSubsidy4k.RequestedSnn4k">
              Is er eerder gebruik gemaakt van de Waardevermeerderingsregeling Groningen (&euro;4.000) voor uw woning?
            </base-input>

          </base-form>
        <!-- form card end -->
        </base-card>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.financing.snnSubsidy4k.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import VariablePill from "@/components/VariablePill.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"
  // import IssueFeedback from "@/components/IssueFeedback.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
    
  import { LeadDataService } from "@/services/LeadDataService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      // VariablePill,
      CheckmarkItem,
      // IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Weet ik niet',
            value: 'Weet ik niet'
          }
        ]
      };
    },
    computed: {
      showSubsididyRequestedQuestions() {
        return (this.lead.financing.snnSubsidy4k.InVersterking !== null && this.lead.financing.snnSubsidy4k.InVersterking !== 'Ja');
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.ownership.$touch();
        return !this.v$.ownership.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    },
    beforeRouteLeave() {
      LeadDataService.pushRemoteData(this.uiStore.uuid, true);
    }
  }
</script>

<style lang="scss">
</style>